<template>
  <div class="tw:max-w-[275px]" :class="isUser ? 'tw:ml-auto' : 'tw:mr-auto'">
    <p class="tw:text-xs tw:text-gray-500 tw:mb-2" :class="isUser ? 'tw:text-right' : 'tw:text-left'">
      <span v-if="isUser">{{ $t('chatbot_timestamp_hotelier') + ' ' }}</span>
      <span v-else>
        <ArtificialIntelligenceIcon class="tw:inline tw:relative tw:bottom-0.5 tw:mr-1 tw:size-6" />
        <span class="tw:inline">{{ $t('chatbot_timestamp_studio') + ' ' }}</span>
      </span>
      <time :datetime="timestamp.toISOString()" class="tw:inline">{{ formattedTime }}</time>
    </p>
    <p
      v-if="!isUser"
      v-html="formattedMessage"
      class="chat-message tw:rounded-xl tw:p-3 tw:wrap-break-word tw:bg-blue-100 tw:text-black"
    ></p>
    <p v-else class="tw:rounded-xl tw:p-3 tw:wrap-break-word tw:bg-blue-700 tw:text-white">{{ text }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import { authors } from '@/components/chatbot/useChat'
import ArtificialIntelligenceIcon from '@/components/icons/ArtificialIntelligenceIcon.svg?component'
import { parseMarkdown } from '@/utils/marked'

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  author: {
    type: String,
    default: authors.USER,
  },
  timestamp: {
    type: Date,
    required: false,
    default: () => new Date(),
  },
})

const isUser = computed(() => props.author === authors.USER)

const formattedTime = computed(() => {
  return props.timestamp.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
})

const formattedMessage = computed(() => {
  if (props.author === authors.USER) return props.text
  return parseMarkdown(props.text)
})
</script>

<style scoped>
:deep(.chat-message a) {
  word-break: break-all;
}

:deep(.chat-message p:not(:last-of-type)) {
  margin-bottom: 1rem;
}

:deep(.chat-message li) {
  list-style-type: disc;
  margin-left: 1.5rem;
}

:deep(.chat-message ul) {
  margin-bottom: 1rem;
}

:deep(.chat-message ol) {
  margin-bottom: 1rem;
}
</style>
